import { AgentType } from '@lumapps/agent-hub-agents/types';

export const SCOPE = 'agent-library';
export const ITEMS_PER_PAGE = 9;
export const EXCLUDED_TYPES = [AgentType.STATIC_ANSWER, AgentType.RAG];
